import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { 
    BarChart, 
    Bar, 
    XAxis, 
    YAxis, 
    CartesianGrid, 
    Tooltip, 
    ResponsiveContainer, 
    Legend, 
    Cell 
} from "recharts";
import '../../Styles/Admin/CheckinChart.css'; 
import { API_BASE_URL } from "../../apiConfig";

const COLORS = ["#6366F1", "#8B5CF6", "#EC4899", "#10B981", "#F59E0B"];

const CheckinChart = () => {
    const [checkinData, setCheckinData] = useState([]);

    useEffect(() => {
        const fetchCheckinData = async () => {
            try {
                const response = await fetch(`${API_BASE_URL}/admin/attendance-trend`, {
                    method: "GET",
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("idToken")}`,
                    },
                });
                const data = await response.json();
                if (data.success) {
                    // Map to recharts format: { name: date, value: checkIns }
                    let trend = data.trend.map(item => ({ name: item.date, value: item.checkIns }));
                    // Only keep the last 7 days
                    if (trend.length > 7) {
                        trend = trend.slice(-7);
                    }
                    setCheckinData(trend);
                } else {
                    setCheckinData([]);
                    console.error("Failed to fetch check-in data:", data.message);
                }
            } catch (err) {
                setCheckinData([]);
                console.error("Error fetching check-in data:", err);
            }
        };
        fetchCheckinData();
    }, []);

    return (
        <motion.div
            className="sales-chart-container"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
        >
            <h2 className="sales-chart-title">
                Daily Check-Ins
            </h2>

            <div className="chart-container">
                <ResponsiveContainer>
                    <BarChart data={checkinData}>
                        <CartesianGrid 
                            strokeDasharray="3 3" 
                            stroke="#4B5563" 
                        />
                        <XAxis 
                            dataKey="name" 
                            stroke="#9CA3AF" 
                        />
                        <YAxis stroke="#9CA3AF" />
                        <Tooltip
                            contentStyle={{
                                backgroundColor: "rgba(31, 41, 55, 0.8)",
                                borderColor: "#4B5563",
                            }}
                            itemStyle={{ color: "#E5E7EB" }}
                        />
                        <Legend />
                        <Bar dataKey="value" fill="#8884d8">
                            {checkinData.map((entry, index) => (
                                <Cell 
                                    key={`cell-${index}`} 
                                    fill={COLORS[index % COLORS.length]} 
                                />
                            ))}
                        </Bar>
                    </BarChart>
                </ResponsiveContainer>
            </div>
        </motion.div>
    );
};

export default CheckinChart;
